module.exports = __webpack_public_path__ + "media/img/event/sponsor/ringgit-plus_logo-b2292fdd23a4876f69375323e8062703.png";